/**
 * Spanish Features Translations
 * 特性翻译模块 - 西班牙语
 * 
 * SEO 关键词覆盖：
 * - calefactor infrarrojo / calefacción radiante
 * - eficiencia energética / ahorro energético
 * - recubrimiento nano / emisividad
 */

import type { FeaturesTranslations } from '../../types';

export const esFeatures: FeaturesTranslations = {
  tech: {
    title: 'Elemento de Calefacción Innovador de Infrarrojo Lejano',
    description: 'Los calefactores infrarrojos JH emiten rayos infrarrojos lejanos que calientan directamente a las personas y los objetos — igual que la luz natural del sol. Esta calefacción radiante proporciona calor rápido, uniforme y silencioso — sin ruido, viento, luz ni polvo — con un consumo energético hasta un 80% menor que los calefactores de convección convencionales.',
    aluminum: 'Aleación de aluminio especial tipo aleteado para rápida conducción de calor',
    nano: 'Recubrimiento NANO-cerámico patentado para máxima emisión de infrarrojo lejano',
    insulation: '86% de eficiencia de emisión de rayos infrarrojos lejanos — líder en la industria',
    lifespan: 'Tecnología patentada de almacenamiento de calor reflectante (+20% ahorro energético)',
  },
};
